import lscache from "lscache";

const MINUTE = 1;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const MONTH = DAY * 30;

export default {
    MINUTE,
    HOUR,
    DAY,
    MONTH,
    set: function (key, value, expiresIn) {
        lscache.set(key, value, expiresIn);
    },
    get: function (key) {
        return lscache.get(key);
    },
    remove: function (key) {
        lscache.remove(key);
    },
    clear: function() {
        lscache.flush();
    },
    clearExpired: function () {
        lscache.flushExpired();
    },
};
